import Service from "../../Service";

const resource = "HmnStaffingRequirement/";

export default {
  save(item, requestID) {
    return Service.post(resource + "save", item, {
      params: { requestID: requestID },
    });
  },
  list(requestID) {
    return Service.post(resource + "list", null, {
      params: { requestID: requestID },
    });
  },
  pagination(parameters, requestID) {
    return Service.post(resource + "paginate", parameters, {
      params: { requestID: requestID },
    });
  },
  byID(reqID, requestID) {
    return Service.post(resource + "byID", null, {
      params: { reqID: reqID, requestID: requestID },
    });
  },
  saveAdjustedProjections(projections, requestID) {
    return Service.post(resource + "saveAdjustedProjections", projections, {
      params: { requestID: requestID },
    });
  },
  projectionHistory(reqID, requestID) {
    return Service.post(resource + "projectionHistory", null, {
      params: { reqID: reqID, requestID: requestID },
    });
  },
  checkActive(payloadOrCmpID, reqPstIDOrRequestID, requestID, currentReqID) {
    let payload = {};
    let reqID = requestID;
    if (typeof payloadOrCmpID === "object" && payloadOrCmpID !== null) {
      payload = payloadOrCmpID;
      reqID = reqPstIDOrRequestID;
    } else {
      payload = {
        cmpID: payloadOrCmpID,
        reqPstID: reqPstIDOrRequestID,
        currentReqID: currentReqID || 0,
      };
      reqID = requestID;
    }
    return Service.post(resource + "checkActive", payload, {
      params: { requestID: reqID },
    });
  },
  traceabilityTree(reqID, requestID) {
    return Service.post(resource + "traceabilityTree", { reqID: reqID }, {
      params: { requestID: requestID },
    });
  },
  delete(reqID, requestID) {
    return Service.post(resource + "delete", null, {
      params: { reqID: reqID, requestID: requestID },
    });
  },
  remove(item, requestID) {
    const id = item?.ReqID || item?.ID || item;
    return Service.post(resource + "delete", null, {
      params: { reqID: id, requestID: requestID },
    });
  },
};